// Filename: views/layout/supervisor.js
define('views/modules/stats/week-stats',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // models
    'collections/stats/week-stats',
    // views
    'views/parts/info-section',
    'views/modules/stats/stat',
    // templates
    'text!templates/modules/stats/week-stats.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // models
    CWeekStats,
    // views
    VInfoSection,
    VStat,
    // templates
    TWeekStats
) {

    var VWeekStats = Backbone.View.extend({
        template: TWeekStats,

        regions: {
            list: '.week-stat-list',
            calories: '.calories',
            distance: '.distance',
            duration: '.duration',
            points: '.points'
        },

        initialize: function(opt) {
            opt = opt || {};

            var model = this.model,
                collection = this.collection = new CWeekStats(),
                view = this.view = {
                    info: new VInfoSection({
                        title: "Your Stats",
                        content: this.template,
                        // buttonTop: {
                        //     link: '#/',
                        //     text: 'Edit my stats',
                        //     displayIcon: false,
                        // }
                    }),
                    calories: new VStat({
                        name: 'calories',
                    }),
                    distance: new VStat({
                        name: 'distance',
                        profile: model
                    }),
                    duration: new VStat({
                        name: 'duration',
                    }),
                    points: new VStat({
                        name: 'points',
                    })
                };

            this.listenTo(this.collection, { 'sync': this.onCollectionSync });
        },

        render: function() {
            var view = this.view;
            this.assign(view.info, this.$el);

            this.generateZones();
            var zone = this.zone;

            this.assign(view.calories, zone.$calories)
                .assign(view.distance, zone.$distance)
                .assign(view.duration, zone.$duration);
                //.assign(view.points, zone.$points);

            this.collection.fetch();

            return this;
        },

        onCollectionSync: function(collection) {
            var view = this.view;
            collection.each(function(model) {
                if (view[model.id]) {
                    view[model.id].resetModel(model.attributes);
                }
            });
        },

    });

    return VWeekStats;

});

